const asyncTypes = {
  REQUEST: 'REQUEST',
  PENDING: 'PENDING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
};

export function createAsyncTypes(type: string) {
  return Object.keys(asyncTypes).reduce<{ [x: string]: string }>((acc, curr) => {
    acc[curr] = `${type}_${curr}`;
    return acc;
  }, {});
}
